(function() {
  function initCard(card) {
    if (card.dataset.navInited === 'true') return;
    card.dataset.navInited = 'true';

    var panel = card.parentElement
      ? card.parentElement.querySelector('[data-feature-panel]')
      : null;
    if (!panel) return;

    var closeBtn = panel.querySelector('[data-feature-panel-close]');

    function closePanel() {
      panel.classList.add('is-closing');
      panel.addEventListener('animationend', function onEnd() {
        panel.removeEventListener('animationend', onEnd);
        panel.classList.remove('is-closing');
        if (typeof panel.close === 'function') {
          panel.close();
        } else {
          panel.removeAttribute('open');
        }
      }, { once: true });
    }

    card.addEventListener('click', function() {
      if (typeof panel.showModal === 'function') {
        panel.showModal();
      } else {
        panel.setAttribute('open', '');
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closePanel);
    }

    panel.addEventListener('click', function(e) {
      if (e.target === panel) {
        closePanel();
      }
    });
  }

  function initCards() {
    document.querySelectorAll('[data-feature-highlights]').forEach(initCard);
  }

  initCards();
  document.addEventListener('site:navigation:end', initCards);
})();
